import {Action, createSelector, Selector, State, StateContext} from '@ngxs/store';
import {Dictionary} from '../../models/dictionary.model';
import {DictionaryService} from '../../services/dictionary.service';
import {upsertEntity} from '../../helpers/state-operators.helper';
import {Injectable} from '@angular/core';
import {DictionaryCode} from '../../enums/dictionary-code.enum';
import {EntityState} from '../../models/entity-state.model';
import {DictionaryActions} from './dictionary.actions';
import {of} from 'rxjs';
import {map} from 'rxjs/operators';

interface IDictionaryState extends EntityState<Dictionary> {
}

@State<IDictionaryState>({
    name: 'dictionary',
    defaults: {
        entities: {},
        codes: []
    }
})

@Injectable()
export class DictionaryState {
    constructor(private dictionaryService: DictionaryService) {
    }

    static getDictionary(code: DictionaryCode) {
        return createSelector([DictionaryState], (state: IDictionaryState) => {
            return state.entities[code];
        });
    }

    static getFilteredDictionary(code: DictionaryCode, filter: string) {
        return createSelector([DictionaryState], (state: IDictionaryState) => {
            const dictionary = state.entities[code];
            return {
                ...dictionary,
                itemList: dictionary.itemList.filter(item => item.flexField1 === filter)
            };
        });
    }

    @Selector()
    static dictionaries(state) {
        return state.codes.length ? state.codes.map(code => state.entities[code]) : undefined;
    }

    @Action(DictionaryActions.Download)
    download(ctx: StateContext<IDictionaryState>, action: DictionaryActions.Download) {
        const codes: string[] = Array.isArray(action.codes)
            ? action.codes
            : [action.codes];
        const toFetch = codes.filter(code => ctx.getState().codes.indexOf(code) === -1);
        if (toFetch.length > 0) {
            return this.dictionaryService.fetchDictionaries(toFetch)
                .pipe(map(result => {
                    result.forEach(dictionary => ctx.setState(upsertEntity(dictionary)));
                    return true;
                }));
        }
        return of(false);
    }
}
